import { useAppSelector } from "store/store";

const useUserRole = () => {
    const { userRole } = useAppSelector((state) => state.settings);

    return { userRole };
};

export default useUserRole;
